"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceState = exports.DeviceStatus = exports.DeviceLocation = exports.Location = void 0;
var Location;
(function (Location) {
    Location["PARIS"] = "PARIS";
    Location["LAUSANNE"] = "LAUSANNE";
    Location["BOSTON"] = "BOSTON";
})(Location = exports.Location || (exports.Location = {}));
var DeviceLocation;
(function (DeviceLocation) {
    DeviceLocation["PARIS"] = "Stock FR - Sales";
    DeviceLocation["LAUSANNE"] = "Stock CH - Sales";
    DeviceLocation["BOSTON"] = "Stock USA - Sales";
})(DeviceLocation = exports.DeviceLocation || (exports.DeviceLocation = {}));
var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["OPERATIONAL"] = "Operational";
})(DeviceStatus = exports.DeviceStatus || (exports.DeviceStatus = {}));
var DeviceState;
(function (DeviceState) {
    DeviceState["FOR_SALE"] = "For sale";
})(DeviceState = exports.DeviceState || (exports.DeviceState = {}));
